import React from 'react';
import bg from '../../../images/login/login_bg.svg';
import logo from '../../../images/login/logo_uni.svg';
import bottom_pattern from '../../../images/login/bottom_pattern.svg';
import bottom_pattern2 from '../../../images/login/bottom_pattern_2.svg';
import ListView from "../../ListView/ListView";

export default class GameSelector extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentGame: "",
            currentEl: -1
        };
    }

    selectCurrentGame(elem, gameID) {
        this.setState({
            currentGame: gameID,
            currentEl: elem
        });
    }

    render() {
        const games = this.props.games.map((el, i) => <div key={i} className={"select__game" + (this.state.currentEl === i ? " selected" : "")} onClick={() => {this.selectCurrentGame(i, el.uuid)}}>{el.name}</div>);
        const listView = <ListView children={games} onSelect={() => this.props.onSelect(this.state.currentGame)} disabled={!this.state.currentGame} />

        return (
            <div className="login-page">
                <img src={logo} className="login-logo" alt="Корпоративный Университет РЖД"/>
                <img src={bg} className="login-bg-element" alt="icon"/>
                <img src={bottom_pattern} className="login-bottom-pattern" alt="icon"/>
                <img src={bottom_pattern2} className="login-bottom-pattern-2" alt="icon"/>

                {listView}
            </div>
        );
    }
}
